//// Redirect function
var myDomain = window.ikyuUrls.otoriyoseUrl;
var ikyuDomain = window.ikyuUrls.accountUrl;
var CHECKOUT_RESUME_STORAGE_KEY = "checkoutUrl";
var LEGACY_CHECKOUT_RESUME_STORAGE_KEY = "checkoutUrl2";
var CHECKOUT_RESUME_COOKIE_KEY = "checkout_resume_url";
var CHECKOUT_RESUME_CREATED_AT_STORAGE_KEY = "checkoutResumeCreatedAt";
var CHECKOUT_RESUME_MAX_AGE_MS = 30 * 60 * 1000;
var RETURN_TO_QUERY_KEY = "return_to";
var RESUME_LOGIN_QUERY_KEY = "resume_login";

// Add debug logging
// console.log('Current URLs:', { myDomain, ikyuDomain });

const environments = {
    production: "otoriyose.ikyu.com",
    staging: "stg-otoriyose.ikyu.com",
    development: "dev-otoriyose.ikyu.com",
};
const currentEnvironment = window.location.hostname;

// Get a URL
var recent = location.pathname.replace(/\/+$/, "") || "/";
var ref = document.referrer;

if (window.checkoutResumeDebug) {
    window.checkoutResumeDebug.record("sync_loaded", {
        loggedIn: window.ikyuCustomerLoggedIn === true,
        pathType: recent === "/account" ? "account" : "other",
        referrerType: window.checkoutResumeDebug.getReferrerType(),
    });
}

function getResumeCookieDomain() {
    if (window.location.hostname === "ikyu.com" || window.location.hostname.endsWith(".ikyu.com")) {
        return ".ikyu.com";
    }

    return window.location.hostname;
}

function readResumeCookie() {
    var cookiePrefix = CHECKOUT_RESUME_COOKIE_KEY + "=";
    var cookies = document.cookie ? document.cookie.split("; ") : [];

    for (var i = 0; i < cookies.length; i++) {
        if (cookies[i].indexOf(cookiePrefix) === 0) {
            return decodeURIComponent(cookies[i].substring(cookiePrefix.length));
        }
    }

    return null;
}

function clearResumeCookie() {
    var domain = getResumeCookieDomain();
    var cookie = CHECKOUT_RESUME_COOKIE_KEY + "=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax";

    if (domain) {
        cookie += "; domain=" + domain;
    }

    if (window.location.protocol === "https:") {
        cookie += "; secure";
    }

    document.cookie = cookie;
}

function isValidReturnTo(rawUrl) {
    if (!rawUrl || rawUrl === "undefined" || rawUrl === "null") {
        return false;
    }

    try {
        var candidateUrl = new URL(rawUrl, myDomain);
        var shopHost = new URL(myDomain).hostname;
        var storefrontHost = new URL(window.ikyuUrls.storefrontApiUrl).hostname;
        var blockedPaths = [
            "/account",
            "/account/login",
            "/account/register",
            "/pages/ikyu-login",
            "/pages/checkout-login",
            "/pages/logout",
        ];

        if (candidateUrl.hostname !== shopHost && candidateUrl.hostname !== storefrontHost) {
            return false;
        }

        if (candidateUrl.pathname.indexOf("/account/") === 0 || blockedPaths.indexOf(candidateUrl.pathname) !== -1) {
            return false;
        }

        return true;
    } catch (error) {
        console.warn("Invalid return_to URL:", rawUrl, error);
        return false;
    }
}

function getStoredReturnTo() {
    var queryReturnTo = getUrlSearchParam(RETURN_TO_QUERY_KEY);

    if (isValidReturnTo(queryReturnTo)) {
        return queryReturnTo;
    }

    var cookieReturnTo = readResumeCookie();
    if (isValidReturnTo(cookieReturnTo)) {
        return cookieReturnTo;
    }

    var storedReturnTo = localStorage.getItem(CHECKOUT_RESUME_STORAGE_KEY);
    if (isValidReturnTo(storedReturnTo)) {
        return storedReturnTo;
    }

    var legacyReturnTo = localStorage.getItem(LEGACY_CHECKOUT_RESUME_STORAGE_KEY);
    if (isValidReturnTo(legacyReturnTo)) {
        return legacyReturnTo;
    }

    return null;
}

function getPendingReturnTo() {
    // document.referrer や Cookie はブラウザ・リダイレクト経路によって利用できない場合がある。
    // main互換のcheckoutUrl2もreferrerに依存せず復帰候補として扱う。
    var storedReturnTo = localStorage.getItem(CHECKOUT_RESUME_STORAGE_KEY);
    var legacyReturnTo = localStorage.getItem(LEGACY_CHECKOUT_RESUME_STORAGE_KEY);
    var createdAt = Number(localStorage.getItem(CHECKOUT_RESUME_CREATED_AT_STORAGE_KEY));
    var stateAge = Date.now() - createdAt;
    var hasFreshStoredState = createdAt > 0
        && stateAge >= 0
        && stateAge <= CHECKOUT_RESUME_MAX_AGE_MS;

    if (hasFreshStoredState && isValidReturnTo(storedReturnTo)) {
        return storedReturnTo;
    }

    if (isValidReturnTo(legacyReturnTo)) {
        return legacyReturnTo;
    }

    var cookieReturnTo = readResumeCookie();

    if (isValidReturnTo(cookieReturnTo)) {
        return cookieReturnTo;
    }

    return null;
}

function clearStoredReturnTo() {
    localStorage.removeItem(CHECKOUT_RESUME_STORAGE_KEY);
    localStorage.removeItem(LEGACY_CHECKOUT_RESUME_STORAGE_KEY);
    localStorage.removeItem(CHECKOUT_RESUME_CREATED_AT_STORAGE_KEY);
    clearResumeCookie();
}

function getUrlSearchParam(paramName) {
    return new URLSearchParams(window.location.search).get(paramName);
}

function renderCheckoutResumeFallback(cartPath) {
    var progress = document.getElementById("checkout-resume-progress");
    if (progress) {
        progress.remove();
    }

    if (document.getElementById("checkout-resume-fallback")) {
        return;
    }

    var container = document.createElement("section");
    var heading = document.createElement("h2");
    var description = document.createElement("p");
    var link = document.createElement("a");

    container.id = "checkout-resume-fallback";
    container.className = "checkout-resume-fallback page-width";
    container.setAttribute("aria-labelledby", "checkout-resume-fallback-title");
    heading.id = "checkout-resume-fallback-title";
    heading.className = "checkout-resume-fallback__title";
    heading.textContent = "ログインが完了しました";
    description.className = "checkout-resume-fallback__description";
    description.textContent = "カートに戻って購入手続きを続けてください。";
    link.className = "button button--primary checkout-resume-fallback__button";
    link.href = cartPath;
    link.textContent = "購入手続きを続ける";

    container.appendChild(heading);
    container.appendChild(description);
    container.appendChild(link);
    document.body.insertBefore(container, document.body.firstChild);
}

function renderCheckoutResumeProgress() {
    if (document.getElementById("checkout-resume-progress")) {
        return;
    }

    var container = document.createElement("section");
    var content = document.createElement("div");
    var heading = document.createElement("h2");
    var description = document.createElement("p");
    var indicator = document.createElement("span");
    var progressUi = window.checkoutResumeUi || {};

    container.id = "checkout-resume-progress";
    container.className = "checkout-resume-progress";
    container.setAttribute("aria-labelledby", "checkout-resume-progress-title");
    container.setAttribute("aria-live", "polite");
    container.setAttribute("role", "status");
    content.className = "checkout-resume-progress__content";
    heading.id = "checkout-resume-progress-title";
    heading.className = "checkout-resume-progress__title";
    heading.textContent = progressUi.title || "購入手続きへ移動しています";
    description.className = "checkout-resume-progress__description";
    description.textContent = progressUi.description || "そのままお待ちください";
    indicator.className = "checkout-resume-progress__indicator";
    indicator.setAttribute("aria-hidden", "true");

    content.appendChild(heading);
    content.appendChild(description);
    content.appendChild(indicator);
    container.appendChild(content);
    document.body.appendChild(container);
}

// NOTE: 新しいお客様アカウントへの移行に伴い、以下のレガシー処理を削除した。
// - /account/login, /account/register へのクリックを /pages/ikyu-login (Multipass 前提) へ
//   書き換えるクリックインターセプタ
// - /account/login, /account/register 表示時に /pages/ikyu-login へ転送する switch case
// これらのルートは Shopify が新しいお客様アカウントの認証フロー(custom IdP)へ
// サーバーサイドでリダイレクトするため、テーマ側での乗っ取りは不要かつ有害。

switch (recent) {
    case "/account": // Redirect to home if user just logged in
        var cameFromIkyuAccount = ref.indexOf(ikyuDomain) != -1;
        var pendingLoginResume = window.ikyuCustomerLoggedIn === true
            && window.checkoutResumeState
            ? window.checkoutResumeState.getPendingLogin()
            : null;

        if (pendingLoginResume) {
            var resumeCartPath = window.checkoutResumeState.getResumeCartPath();
            clearStoredReturnTo();
            window.checkoutResumeState.clearLegacyCheckoutState();

            if (typeof window.resumeCheckoutAfterLogin !== "function") {
                if (window.checkoutResumeDebug) {
                    window.checkoutResumeDebug.record("account_resume_failed", {
                        attempts: pendingLoginResume.attempts,
                        error: "ResumeFunctionUnavailable",
                        intentStatus: pendingLoginResume.status,
                        result: "stay",
                        targetType: "cart",
                        vendorPresent: true,
                    });
                }

                renderCheckoutResumeFallback(resumeCartPath);
                break;
            }

            if (window.checkoutResumeDebug) {
                window.checkoutResumeDebug.record("account_resume_checkout", {
                    action: "checkout-create",
                    attempts: pendingLoginResume.attempts,
                    intentStatus: pendingLoginResume.status,
                    result: "start",
                    targetType: "checkout",
                    vendorPresent: true,
                });
            }

            renderCheckoutResumeProgress();
            window.resumeCheckoutAfterLogin({ allowAccount: true }).then(function (resumed) {
                if (resumed) {
                    return;
                }

                if (window.checkoutResumeDebug) {
                    window.checkoutResumeDebug.record("account_resume_failed", {
                        error: "CheckoutCreateFailed",
                        result: "stay",
                        targetType: "cart",
                    });
                }

                renderCheckoutResumeFallback(resumeCartPath);
            }).catch(function (error) {
                if (window.checkoutResumeDebug) {
                    window.checkoutResumeDebug.record("account_resume_failed", {
                        error: error && error.name ? error.name : "CheckoutCreateError",
                        result: "stay",
                        targetType: "cart",
                    });
                }

                renderCheckoutResumeFallback(resumeCartPath);
            });
            break;
        }

        var checkoutUrl = getPendingReturnTo();

        // Cookie が利用できない既存ブラウザ向けに、従来の referrer + storage 経路を残す。
        if (!checkoutUrl && cameFromIkyuAccount) {
            checkoutUrl = getStoredReturnTo();
        }

        if (window.checkoutResumeDebug) {
            window.checkoutResumeDebug.record("account_resume_decision", {
                referrerType: window.checkoutResumeDebug.getReferrerType(),
                result: checkoutUrl ? "redirect" : "stay",
                targetType: window.checkoutResumeDebug.classifyUrl(checkoutUrl),
            });
        }

        if (checkoutUrl) {
            document.body.style.display = "none"; //読み込み遅いためページ全てを非表示
            console.log('Checkout URL:', checkoutUrl);
            if (window.checkoutResumeDebug) {
                window.checkoutResumeDebug.record("account_redirect_called", {
                    action: "location-href",
                    targetType: window.checkoutResumeDebug.classifyUrl(checkoutUrl),
                });
            }
            clearStoredReturnTo();
            window.location.href = checkoutUrl;
            break;
        }

        if (cameFromIkyuAccount) {
            document.body.style.display = "none"; //読み込み遅いためページ全てを非表示
            if (window.checkoutResumeDebug) {
                window.checkoutResumeDebug.record("account_cart_fallback", {
                    action: "location-href",
                    targetType: "cart",
                });
            }
            window.location.href = "/cart";
        }
        break;
    case "/pages/phone-account":
        var uri = myDomain + "/pages/phone-account";
        var urie = encodeURIComponent(url);
        var exurl = ikyuDomain + "/logout?dest=" + urie;
        window.location.href = exurl;
        break;
    case "/pages/logout":
        $("body").hide();
        var url = window.location.href;
        var queryParams = getQueryParams(url);
        var destUrl = queryParams["dest"];

        $.ajax("/account/logout/").done(function () {
            window.location.href = destUrl;
        });
        break;
    case "/pages/ikyu-login":
        // 何もしない
        break;
    default:
        document.addEventListener('alpine:init', () => {
            Alpine.store('otoriyoseGlobal').allHidden = false;
            console.log("Toggled: allHidden to false");
        });

        if (ref.indexOf(ikyuDomain) != -1 && isValidReturnTo(window.location.href)) {
            clearStoredReturnTo();
        }
}

// Logout process
$(".logout-link").on("click", function () {
    var uri = myDomain + "/account/logout/";
    var urie = encodeURIComponent(uri);
    var exurl = ikyuDomain + "/logout?dest=" + urie;
    window.location.href = exurl;
});

// URLからクエリパラメータを取得する関数
function getQueryParams(url) {
    var queryParams = {};
    var queryString = url.split("?")[1];

    if (queryString) {
        var paramPairs = queryString.split("&");

        for (var i = 0; i < paramPairs.length; i++) {
            var pair = paramPairs[i].split("=");
            var paramName = decodeURIComponent(pair[0]);
            var paramValue = decodeURIComponent(pair[1]);
            queryParams[paramName] = paramValue;
        }
    }

    return queryParams;
}
